import type { FC } from "react";
import React from "react";

import { Image } from "../Image/Image";

interface ILibraryLogoProps {
  logoPath: string;
  logoRatio?: number | null;
}

const BASE_URL = "https://www.litres.ru";

export const LibraryLogo: FC<ILibraryLogoProps> = ({ logoPath, logoRatio }) => {
  return (
    <Image
      src={BASE_URL + logoPath}
      fallbackSrc={logoPath}
      width={logoRatio ? 72 * logoRatio : 72}
      height={72}
      alt="litres-library-logo"
      style={{
        marginLeft: "10px",
      }}
    />
  );
};
